import { useDocument } from '@/shared/firebase/hooks/useDocument'

export interface Employee {
    id: string
    name: string
}

export interface GlobalPrivateConfig {
    employees?: Employee[]
    id: string
}

export interface GlobalPublicConfig {
    phoneNumber: string
    id: string
    hotelHours: {
        morning: {
            open: string
            close: string
        }
        afternoon: {
            open: string
            close: string
        }
    }
}

export function useGlobalPrivateConfig() {
    const {
        document: data,
        isLoading: loading,
        error,
    } = useDocument<GlobalPrivateConfig>({
        collectionName: 'configs',
        id: 'global_configs_private',
    })

    return {
        data,
        loading,
        error,
    }
}

export function useGlobalPublicConfig() {
    const {
        document: data,
        isLoading: loading,
        setDocument: setGlobalPublicConfig,
    } = useDocument<GlobalPublicConfig>({
        collectionName: 'configs',
        id: 'global_configs_public',
        defaultValue: {
            phoneNumber: '',
            id: '',
            hotelHours: {
                morning: { open: '09:00', close: '14:00' },
                afternoon: { open: '16:00', close: '20:00' },
            },
        },
    })

    return {
        data,
        loading,
        setGlobalPublicConfig,
    }
}
